import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const BulkVendorAPi = createApi({
  reducerPath: "BulkVendorAPi",
  baseQuery: authBaseQuery,
  tagTypes: [],
  endpoints: (builder) => ({
    getBulkVendorData: builder.query({
      query: () => {
        return `v1/bulk_vendor_data`;
      },
    }),

    getSingleBulkVendorById: builder.query({
      query: (id) => {
        return `v1/get_single_bulk_vendor/${id}`
      },
    }),

    editBulkVendorData: builder.mutation({
      query: (payload) => ({
        url: `v1/edit_bulk_vendor_data`,
        method: "PUT",
        body: payload,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const {
  useGetBulkVendorDataQuery,
  useLazyGetSingleBulkVendorByIdQuery,
  useEditBulkVendorDataMutation,
} = BulkVendorAPi;

export default BulkVendorAPi;
